import {User} from 'src/app/core/models/user.model';
import {ITopVertical} from 'src/app/modules/dashboard/models/i-top-vertical';
import {ITotalClicks} from 'src/app/modules/dashboard/models/i-total-clicks';
import {Vertical} from 'src/app/modules/maintenance/models/links/vertical';
import {Site} from 'src/app/modules/maintenance/models/site/site';

export interface StatsModel {
  topVerticals: ITopVertical[] | null;
  trends: Record<string, number[]> | null;
  totalClicks: ITotalClicks | null;
}

export interface AffiliateSitesEntry {
  sites: Site[];
  withLinks: boolean;
}

export interface SessionStateModel {
  token: string | null;
  user: User | null;
  stats: StatsModel;
  verticals: Vertical[] | null;
  sitesByAffiliate: Record<number, AffiliateSitesEntry>;

  /**
   * Transient: result of the most recent SaveSite. Dispatch observables don't carry
   * handler results, so components snapshot this right after dispatching SaveSite.
   */
  lastSavedSite: Site | null;

  /** UI preference, persisted by the storage plugin and kept across Logout. */
  isWidescreen: boolean;
}

export class GoogleLogin {
  static readonly type = '[Session] Google Login';

  constructor(public code: string) {
  }
}

export class Logout {
  static readonly type = '[Session] Logout';
}

export class ToggleWidescreen {
  static readonly type = '[Session] Toggle Widescreen';
}

export class FetchUser {
  static readonly type = '[Session] Fetch User';
}

export class FetchStats {
  static readonly type = '[Session] Fetch Stats';

  constructor(public force = false) {
  }
}

export class FetchVerticals {
  static readonly type = '[Session] Fetch Verticals';

  constructor(public force = false) {
  }
}

export class CreateVertical {
  static readonly type = '[Session] Create Vertical';

  constructor(public name: string) {
  }
}

export class UpdateVertical {
  static readonly type = '[Session] Update Vertical';

  constructor(public vertical: Vertical) {
  }
}

export class DeleteVertical {
  static readonly type = '[Session] Delete Vertical';

  constructor(public id: number) {
  }
}

export class FetchSites {
  static readonly type = '[Session] Fetch Sites';

  constructor(public affiliateId: number, public withLinks = false, public force = false) {
  }
}

export class SaveSite {
  static readonly type = '[Session] Save Site';

  constructor(public site: Site) {
  }
}
